import React, { useReducer, createContext, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { contentReducer, contentInitialState } from "../reducers";
import constant from "../constants/contentConstant";
import { contentService } from "../services";
import { history } from "../tools";
import { toast } from "react-toastify";

export const ContentContext = createContext({
    state: contentInitialState,
    actions: {
        search: () => { },
        paginate: () => { },
        goToDetail: () => { }
    }
});

export const ContentContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(contentReducer, contentInitialState);

    const search = useCallback((key) => {
        dispatch({ type: constant.SEARCH_REQUEST });
        contentService
            .search(key)
            .then((response) => {
                if (!response.success) {
                    toast.error(response.message);
                    dispatch({ type: constant.SEARCH_FAIL });
                    return;
                }
                dispatch({ type: constant.SEARCH_SUCCESS, payload: response.data });
            })
            .catch(() => {
                toast.error("the content couldn't be fetched!");
                dispatch({ type: constant.SEARCH_FAIL });
            });
    }, []);

    const paginate = useCallback((dto) => {
        dispatch({ type: constant.PAGINATE_REQUEST });
        contentService
            .paginate(dto)
            .then((response) => {
                if (!response.success) {
                    toast.error(response.message);
                    dispatch({ type: constant.PAGINATE_FAIL });
                    return;
                }
                dispatch({ type: constant.PAGINATE_SUCCESS, payload: response.data });
            })
            .catch(() => {
                toast.error("contents couldn't be fetched!");
                dispatch({ type: constant.PAGINATE_FAIL });
            });
    }, []);

    const goToDetail = useCallback((data) => {
        history.push(`/${data.kind}/${data.id}`);
    }, []);

    const actions = useMemo(
        () => ({ search, paginate, goToDetail }),
        [search, paginate, goToDetail]
    );

    const value = useMemo(() => ({ state, actions }), [state, actions]);

    return (
        <ContentContext.Provider value={value}>
            {children}
        </ContentContext.Provider>
    );
};

ContentContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};
